module.exports = __webpack_public_path__ + "static/media/beforeImage.305a76ff.png";